<template>
  <v-container id="importar-produtos">
    <v-card>
      <v-card-text>Importação de produtos da saúde</v-card-text>
      <page-title
        icon="mdi-pencil-box-outline"
        main="Secretaria de Saúde"
        sub="Importa arquivo de medicamentos"
        home="/saude"
      />
      {{ produtos.linha }}
      <v-row>
        <v-col
          cols="12"
          md="8"
        >
          <input
            accept=".xlsx,.xls"
            type="file"
            ref="file"
            @change="selectFile()"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-btn color="primary" @click="enviarParaBanco" v-if="produtos.length > 0">
            Enviar Medicamentos
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>
<script>
import PageTitle from '@/components/template/PageTitle'
import * as XLSX from 'xlsx'
import { mapState } from 'vuex'
import { baseApiUrl } from '@/global'
// ,showError
import moment from 'moment'
import axios from 'axios'
export default {
  components: { PageTitle },
  name: 'ImportarProdutos',
  computed: mapState(['user']),
  data: () => ({
    file: null,
    produtos: []
  }),
  methods: {
    selectFile () {
      this.file = this.$refs.file.files[0]
      if (!this.file) return
      const reader = new FileReader()
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result)
        const workbook = XLSX.read(data, { type: 'array', raw: true })
        const sheet = workbook.Sheets[workbook.SheetNames[0]]
        const rows = XLSX.utils.sheet_to_json(sheet, { header: 1 })
        this.produtos = this.processarProdutos(rows)
      }
      reader.readAsArrayBuffer(this.file)
    },
    normalizarValor (v) {
      if (!v) return null
      let s = v.toString().trim()
      s = s.replace(/\./g, '')
      s = s.replace(/,/g, '.')
      const n = parseFloat(s)
      return isNaN(n) ? null : n
    },
    extrairId (descricao) {
      const match = descricao.match(/BR(\d{7,8})(?:[-U]\d+)?/i)
      return match ? match[1] : null
    },
    extrairIdU (descricao) {
      const match = descricao.match(/U(\d{4})/i)
      return match ? match[1] : null
    },

    ehLinhaIgnorada (texto) {
      if (!texto) return false
      const t = texto.toString().trim().toUpperCase()
      const ignorar = [
        'ESTABELECIMENTO DE SAÚDE',
        'ESTABELECIMENTO DE SAUDE',
        'SMS',
        'FONTE',
        'ESTADUAL + FEDERAL'
      ]

      return ignorar.some(i => t.includes(i))
    },

    converterDataExcel (value) {
      if (!value) return null

      if (typeof value === 'number') {
        return moment(XLSX.SSF.parse_date_code(value)).format('YYYY-MM-DD')
      }

      if (typeof value === 'string' && value.includes('/')) {
        const [dia, mes, ano] = value.split('/')
        return `${ano}-${mes}-${dia}`
      }

      return null
    },
    processarProdutos (rows) {
      const produtos = []
      let atual = null

      rows.forEach((linha) => {
        if (!linha || linha.length === 0) return

        const descricao = linha[0] || ''
        const ehLinhaDescricao =
          descricao &&
          linha.slice(1, 20).every(col => !col)

        if (ehLinhaDescricao) {
          console.log('🔵 Nova descrição detectada:', descricao)

          if (atual) produtos.push(atual)

          atual = {
            descricao: descricao.trim(),
            idImport: this.extrairId(descricao),
            uid_unidade: this.extrairIdU(descricao),
            movimentacoes: []
          }

          return
        }
        if (atual) {
          const mov = {
            uid_prod: atual.idImport,
            unidade: linha[2] || '',
            fornecedor: linha[3] || '',
            localizacao: `${linha[4] || ''} ${linha[5] || ''}`.trim(),
            programa: `${linha[6] || ''} ${linha[7] || ''}`.trim(),
            validade: this.converterDataExcel(linha[8]),
            lote: linha[9] || '',
            fatorE: `${linha[10] || ''} ${linha[11] || ''}`.trim(),
            bloqueio: `${linha[12] || ''} ${linha[13] || ''} ${linha[14] || ''}`.trim(),
            estoque: this.normalizarValor(`${linha[15] || ''} ${linha[16] || ''}`.trim()),
            valorCompra: this.normalizarValor(linha[17])
          }

          const isLixo =
            (!mov.unidade.trim()) &&
            (!mov.fornecedor.trim()) &&
            (!mov.localizacao.trim()) &&
            (!mov.programa.trim()) &&
            (!mov.lote.trim()) &&
            (
              (mov.fatorE && mov.fatorE.trim()) ||
              (typeof mov.valorCompra === 'number' && !isNaN(mov.valorCompra) && mov.valorCompra > 0)
            )

          if (isLixo) {
            console.log('⚪ Linha ignorada (lixo detectado)')
            return
          }

          atual.movimentacoes.push(mov)
          console.log('🟠 Movimentação detectada:', JSON.stringify(mov, null, 2))
        }

        // if (atual) {
        //   const mov = {
        //     uid_prod: atual.idImport,
        //     unidade: linha[2] || '',
        //     fornecedor: linha[3] || '',
        //     localizacao: `${linha[4] || ''} ${linha[5] || ''}`.trim(),
        //     programa: `${linha[6] || ''} ${linha[7] || ''}`.trim(),
        //     // validade: moment(linha[8]).format('YYYY-MM-DD') || '',
        //     validade: this.converterDataExcel(linha[8]),
        //     lote: linha[9] || '',
        //     fatorE: `${linha[10] || ''} ${linha[11] || ''}`.trim(),
        //     bloqueio: `${linha[12] || ''} ${linha[13] || ''} ${linha[14] || ''}`.trim(),
        //     estoque: this.normalizarValor(`${linha[15] || ''} ${linha[16] || ''}`.trim()),
        //     // valorCompra: this.normalizarValor(`${linha[17] || ''} ${linha[18] || ''}`.trim())
        //     valorCompra: this.normalizarValor(linha[17])
        //   }
        //   const isLixo =
        //     (!mov.unidade || mov.unidade.trim() === '') &&
        //     (!mov.fornecedor || mov.fornecedor.trim() === '') &&
        //     (!mov.localizacao || mov.localizacao.trim() === '') &&
        //     (!mov.programa || mov.programa.trim() === '') &&
        //     (!mov.lote || mov.lote.trim() === '') &&
        //     (
        //       (mov.fatorE && mov.fatorE.trim().length > 0) ||
        //       (mov.valorCompra && mov.valorCompra.trim().length > 0)
        //     )

        //   if (isLixo) {
        //     console.log('⚪ Linha ignorada (lixo detectado)')
        //     return
        //   }

        //   atual.movimentacoes.push(mov)
        //   console.log('🟠 Movimentação detectada:', JSON.stringify(mov, null, 2))
        // }
      })

      if (atual) produtos.push(atual)

      return produtos
    },

    // processarProdutos (rows) {
    //   const produtos = []
    //   let atual = null

    //   rows.forEach((linha) => {
    //     if (!linha || linha.length === 0) return

    //     const descricao = (linha[0] || '').toString().trim()

    //     // 🔥 1. Ignorar linhas que não são produtos
    //     if (this.ehLinhaIgnorada(descricao)) {
    //       console.log('⚪ Linha ignorada (texto especial):', descricao)
    //       return
    //     }

    //     // 🔵 2. Detectar descrição do produto
    //     const ehLinhaDescricao =
    //       descricao &&
    //       linha.slice(1, 20).every(col => !col)

    //     if (ehLinhaDescricao) {
    //       console.log('🔵 Nova descrição detectada:', descricao)

    //       // Salvar anterior
    //       if (atual) produtos.push(atual)

    //       // Criar novo produto
    //       atual = {
    //         descricao,
    //         idImport: this.extrairId(descricao),
    //         uid_unidade: this.extrairIdU(descricao),
    //         movimentacoes: []
    //       }

    //       return
    //     }

    //     // 🟠 3. Linhas de movimentação
    //     if (atual) {
    //       const mov = {
    //         uid_prod: atual.idImport,
    //         unidade: linha[2] || '',
    //         fornecedor: linha[3] || '',
    //         localizacao: `${linha[4] || ''} ${linha[5] || ''}`.trim(),
    //         programa: `${linha[6] || ''} ${linha[7] || ''}`.trim(),
    //         validade: moment(linha[8]).isValid() ? moment(linha[8]).format('YYYY-MM-DD') : null,
    //         lote: linha[9] || '',
    //         fatorE: linha[10] || '',
    //         bloqueio: `${linha[12] || ''} ${linha[13] || ''} ${linha[14] || ''}`.trim(),
    //         estoque: linha[15] || '',
    //         valorCompra: this.normalizarValor(linha[17])
    //       }

    //       // 🟡 Detectar lixo
    //       // const vazio = Object.values(mov).every(v => !v || v === '')

    //       // if (vazio) {
    //       //   console.log('⚪ Movimentação ignorada (vazia)')
    //       //   return
    //       // }
    //       const camposPrincipaisVazios =
    //         (!mov.unidade || mov.unidade.toString().trim() === '') &&
    //         (!mov.fornecedor || mov.fornecedor.toString().trim() === '') &&
    //         (!mov.localizacao || mov.localizacao.toString().trim() === '') &&
    //         (!mov.programa || mov.programa.toString().trim() === '') &&
    //         (!mov.lote || mov.lote.toString().trim() === '')

    //       const semDadosEssenciais =
    //         (!mov.validade || mov.validade === 'Invalid date') &&
    //         (!mov.fatorE || mov.fatorE.toString().trim() === '') &&
    //         (!mov.valorCompra)

    //       const isLixo = camposPrincipaisVazios && semDadosEssenciais

    //       if (isLixo) {
    //         console.log('⚪ Movimentação ignorada (linha sem dados)')
    //         return
    //       }

    //       atual.movimentacoes.push(mov)
    //     }
    //   })

    //   // 🟤 último produto
    //   if (atual) produtos.push(atual)

    //   return produtos
    // },

    async enviarParaBanco () {
      const method = 'post'
      try {
        const res = await axios[method](`${baseApiUrl}/carga-demedicamento-sync`, {
          produtos: this.produtos
        })
        console.log('Importado:', res.data)
        this.$toasted.success('Medicamentos importados com sucesso!')
        this.clear()
      } catch (e) {
        console.error(e)
        this.$toasted.error('Erro ao enviar ao servidor!')
      }
    },
    clear () {
      this.file = null
      this.produtos = []
    }
  }
}
</script>
